__turbopack_context__.v({
  "content": "style-module-scss-module__8jfgya__content",
  "currentMediaImage": "style-module-scss-module__8jfgya__currentMediaImage",
  "currentMediaWrapper": "style-module-scss-module__8jfgya__currentMediaWrapper",
  "newMediaWrapper": "style-module-scss-module__8jfgya__newMediaWrapper",
  "root": "style-module-scss-module__8jfgya__root",
});
